<template>
    <div class='time'>
        <!-- <div>{{now_date}}</div> -->
        <div>

        </div>
        <div class='now_time'>
            <!--<span class='time_name'>时间</span>-->
            <span class="date_time">{{year_month}}</span>
            <span class="bg">{{now_date.H}}</span> :
            <span class='bg'>{{now_date.M}}</span> :
            <span class='bg'>{{now_date.S}}</span>
        </div>

    </div>
</template>

<script>
    export default {
        name: 'time.vue',
        data(){
            return{
                now_date: {
                    H:'',
                    M:'',
                    S:''
                },
                year_month:'',
            }
        },
        mounted(){
            this.init();
        },
        methods:{
            init() {
                this.get_date_time();
            },
            // 获取当前时间
            timeFormate(timeStamp) {
                let year = new Date(timeStamp).getFullYear();
                let month =new Date(timeStamp).getMonth() + 1 < 10? "0" + (new Date(timeStamp).getMonth() + 1): new Date(timeStamp).getMonth() + 1;
                let date =new Date(timeStamp).getDate() < 10? "0" + new Date(timeStamp).getDate(): new Date(timeStamp).getDate();
                let hh =new Date(timeStamp).getHours() < 10? "0" + new Date(timeStamp).getHours(): new Date(timeStamp).getHours();
                let mm =new Date(timeStamp).getMinutes() < 10? "0" + new Date(timeStamp).getMinutes(): new Date(timeStamp).getMinutes();
                let ss =new Date(timeStamp).getSeconds() < 10? "0" + new Date(timeStamp).getSeconds(): new Date(timeStamp).getSeconds();
                this.year_month = year + "-" + month + "-" + date;
                this.now_date = {
                    H:hh,
                    M:mm,
                    S:ss
                }
            },
            // 定时器函数
            get_date_time(){
                this.timeFormate(new Date());
                setTimeout(this.get_date_time,1000);
            },
        },

    }
</script>

<style scoped lang="less">
    .time{
        font-family: dateTime;
        width: 300px;
        font-size: 25px;
        color: #0bdef3;
        font-weight: normal;
        font-stretch: normal;
        letter-spacing: 0px;
        position: absolute;
        top: 22px;
        left: 30px;
        z-index: 9;
        .time_name{
            font-size: 16px;
            color: #ffc602;
        }
        .date_time{
            font-family: dateTime;
            font-size: 22px;
            color: #0bddf6;
        }
        .now_time{
            .bg{
                font-family: dateTime;
                background: #2a2b57;
                text-align: center;
                padding: 1px;
                font-size: 22px;

            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/page/main_content/map/baseMap/time.vue